<div>
  <h1 class="formSection__header">Audit Trail</h1>
  <ng-container *ngIf="auditTrails?.length">
    <div class="esvr-audit-trails-wrapper">
      <table mat-table [dataSource]="auditTrails">
        <ng-container matColumnDef="modifiedDate">
          <th mat-header-cell *matHeaderCellDef>Date & Time</th>
          <td mat-cell *matCellDef="let element">{{ element.modifiedDate | commonDate: 'with24Time' }}</td>
        </ng-container>
        <ng-container matColumnDef="modifiedBy">
          <th mat-header-cell *matHeaderCellDef>Modified By</th>
          <td mat-cell *matCellDef="let element">{{ element.modifiedBy }}</td>
        </ng-container>
        <ng-container matColumnDef="changes">
          <th mat-header-cell *matHeaderCellDef>Changes</th>
          <td mat-cell *matCellDef="let element">
            <table mat-table [dataSource]="element.changes" class="changesTable">
              <ng-container matColumnDef="propertyName">
                <th mat-header-cell *matHeaderCellDef>Property</th>
                <td mat-cell *matCellDef="let element">{{ element.propertyName }}</td>
              </ng-container>
              <ng-container matColumnDef="oldValue">
                <th mat-header-cell *matHeaderCellDef>Old Value</th>
                <td mat-cell *matCellDef="let element">{{ element.oldValue }}</td>
              </ng-container>
              <ng-container matColumnDef="newValue">
                <th mat-header-cell *matHeaderCellDef>New Value</th>
                <td mat-cell *matCellDef="let element">{{ element.newValue }}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedChangesColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedChangesColumns"></tr>
            </table>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </ng-container>
</div>
